<template>
  <div class="provider-payouts">
    <div class="heading">PAYOUTS</div>

    <div class="stripe-accounts">
      <div class="row margin-T">
        <div class="small-8 columns">
          <div class="section-title">
            <span>Available Balance in Stripe as of</span>
            <strong>{{ now.format('MM/DD/YYYY hh:mm A') }}</strong>
          </div>
        </div>
        <div class="small-4 columns">
          <div class="controls">
            <a class="button cta xsmall success" href="javascript:;" @click="refresh">REFRESH</a>
          </div>
        </div>
      </div>

      <div class="row margin-T">

        <div class="small-6 columns padding-R">
          <div class="balances">
            <div class="account-name">Executive Ride</div>
            <div class="row">
              <div class="small-6 columns">
                <div class="balance margin-T-z">
                  <div class="amount">
                    <i class="fa fa-spinner fa-spin" v-show="er.loading"></i>
                    <span v-show="!er.loading">${{ er.available.toFixed(2) }}</span>
                  </div>
                  <div class="label">Available Balance</div>
                </div>
              </div>
              <div class="small-6 columns">
                <div class="balance margin-T-z">
                  <div class="amount">
                    <i class="fa fa-spinner fa-spin" v-show="er.loading || total.loading"></i>
                    <span v-show="!er.loading && !total.loading">${{ requiredER.toFixed(2) }}</span>
                  </div>
                  <div class="label">Balance required for Auto-Deposit</div>
                </div>
              </div>
            </div>
            <div class="row" v-show="!total.isOpenBatch">
              <div class="small-12 columns">
                <div class="payout-controls">
                  <a class="button small cta block margin-T" href="javascript:;" v-show="requiredER > 0" @click="createTopup(true)">
                    <span>Top-up</span>
                    <strong>${{ requiredER.toFixed(2) }}</strong>
                    <span>to Executive Ride</span>
                  </a>
                  <a class="button small cta block success margin-T" href="javascript:;" v-show="requiredER <= 0 && total.er.pending.amount > 0"
                    @click="startAutodeposit(true)">
                    <span>Auto-Deposit</span>
                    <strong>${{ total.er.pending.amount.toFixed(2) }}</strong>
                    <span>to Drivers</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="small-6 columns padding-L">
          <div class="balances">
            <div class="account-name">First Class Transportation</div>
            <div class="row">
              <div class="small-6 columns">
                <div class="balance margin-T-z">
                  <div class="amount">
                    <i class="fa fa-spinner fa-spin" v-show="fct.loading"></i>
                    <span v-show="!fct.loading">${{ fct.available.toFixed(2) }}</span>
                  </div>
                  <div class="label">Available Balance</div>
                </div>
              </div>
              <div class="small-6 columns">
                <div class="balance margin-T-z">
                  <div class="amount">
                    <i class="fa fa-spinner fa-spin" v-show="fct.loading || total.loading"></i>
                    <span v-show="!fct.loading && !total.loading">${{ requiredFCT.toFixed(2) }}</span>
                  </div>
                  <div class="label">Balance required for Auto-Deposit</div>
                </div>
              </div>
            </div>
            <div class="row" v-show="!total.isOpenBatch">
              <div class="small-12 columns">
                <div class="payout-controls">
                  <a class="button small cta block margin-T" href="javascript:;" v-show="requiredFCT > 0" @click="createTopup(false)">
                    <span>Top-up</span>
                    <strong>${{ requiredFCT.toFixed(2) }}</strong>
                    <span>to Executive Ride</span>
                  </a>
                  <a class="button small cta block success margin-T" href="javascript:;" v-show="requiredFCT <= 0 && total.fct.pending.amount > 0"
                    @click="startAutodeposit(false)">
                    <span>Auto-Deposit</span>
                    <strong>${{ total.fct.pending.amount.toFixed(2) }}</strong>
                    <span>to Drivers</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row margin-T">
        <div class="small-7 columns">
          <div class="section-title" v-if="filter.selectedWeek !== null">
            <span>Driver Payouts for</span>
            <div class="payout-dates">
              <strong>{{ filter.selectedWeek.start.format('MM/DD/YYYY') }}</strong>
              <span>to</span>
              <strong>{{ filter.selectedWeek.end.format('MM/DD/YYYY') }}</strong>
            </div>
          </div>
        </div>
        <div class="small-5 columns">
          <div class="select-input">
            <label>Choose a batch:</label>
            <select v-model="filter.selectedWeek" @change="getPayouts">
              <option v-for="(week, index) in filter.weeks" :value="week">
                {{ week.start.format('MMM DD') }} - {{ week.end.format('MMM DD') }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row margin-T margin-B" v-show="!total.isOpenBatch">
        <div class="small-4 columns padding-R">
          <div class="balances">
            <div class="account-name">Executive Ride Payouts</div>
            <div class="totals-group">
              <div class="group-label">PENDING PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.er.pending, 'Executive Ride Payouts', 'pending')">{{ total.er.pending.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.er.pending.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">PAID PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.er.paid, 'Executive Ride Payouts', 'paid')">{{ total.er.paid.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.er.paid.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">IN TRANSIT PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.er.in_transit, 'Executive Ride Payouts', 'in transit')">{{ total.er.in_transit.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.er.in_transit.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">CANCELED PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.er.canceled, 'Executive Ride Payouts', 'canceled')">{{ total.er.canceled.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.er.canceled.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">FAILED PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.er.failed, 'Executive Ride Payouts', 'falied')">{{ total.er.failed.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.er.failed.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
          </div>
        </div>

        <div class="small-4 columns padding-L padding-R">
          <div class="balances">
            <div class="account-name">First Class Transportation Payouts</div>
            <div class="totals-group">
              <div class="group-label">PENDING PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.fct.pending, 'First Class Transportation Payouts', 'pending')">{{ total.fct.pending.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.fct.pending.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">PAID PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.fct.paid, 'First Class Transportation Payouts', 'paid')">{{ total.fct.paid.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.fct.paid.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">IN TRANSIT PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.fct.in_transit, 'First Class Transportation Payouts', 'in transit')">{{ total.fct.in_transit.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.fct.in_transit.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">CANCELED PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.fct.canceled, 'First Class Transportation Payouts', 'canceled')">{{ total.fct.canceled.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.fct.canceled.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">FAILED PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.fct.failed, 'First Class Transportation Payouts', 'failed')">{{ total.fct.failed.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.fct.failed.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
          </div>
        </div>

        <div class="small-4 columns padding-L">
          <div class="balances">
            <div class="account-name">Non Auto-Deposit Payouts</div>
            <div class="totals-group">
              <div class="group-label">PENDING PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.check.pending, 'Non Auto-Deposit Payouts', 'pending')">{{ total.check.pending.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.check.pending.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">PAID PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.check.paid, 'Non Auto-Deposit Payouts', 'paid')">{{ total.check.paid.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.check.paid.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">IN TRANSIT PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.check.in_transit, 'Non Auto-Deposit Payouts', 'in transit')">{{ total.check.in_transit.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.check.in_transit.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">CANCELED PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.check.canceled, 'Non Auto-Deposit Payouts', 'canceled')">{{ total.check.canceled.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.check.canceled.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
            <div class="group-separator"></div>
            <div class="totals-group">
              <div class="group-label">FAILED PAYOUTS</div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading"
                    @click="showProviders(total.check.failed, 'Non Auto-Deposit Payouts', 'failed')">{{ total.check.failed.count }}</span>
                </div>
                <div class="label">Number of Drivers</div>
              </div>
              <div class="balance">
                <div class="amount">
                  <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                  <span v-show="!total.loading">${{ total.check.failed.amount.toFixed(2) }}</span>
                </div>
                <div class="label">Total Amount</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row margin-T margin-B" v-show="total.isOpenBatch">
        <div class="small-6 padding-R columns">
          <div class="balances">
            <div class="account-name">Running Credits</div>
            <div class="balance">
              <div class="amount">
                <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                <span v-show="!total.loading">{{ total.openBatch.credits.count.length }}</span>
              </div>
              <div class="label">Number of Drivers with Credits</div>
            </div>
            <div class="balance">
              <div class="amount">
                <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                <span v-show="!total.loading">${{ total.openBatch.credits.amount.toFixed(2) }}</span>
              </div>
              <div class="label">Total Credits</div>
            </div>
          </div>
        </div>
        <div class="small-6 padding-L columns">
          <div class="balances">
            <div class="account-name">Running Debits</div>
            <div class="balance">
              <div class="amount">
                <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                <span v-show="!total.loading">{{ total.openBatch.debits.count.length }}</span>
              </div>
              <div class="label">Number of Drivers with Debits</div>
            </div>
            <div class="balance">
              <div class="amount">
                <i class="fa fa-spinner fa-spin" v-show="total.loading"></i>
                <span v-show="!total.loading">-(${{ total.openBatch.debits.amount.toFixed(2) }})</span>
              </div>
              <div class="label">Total Debits</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <transition name="fade">
      <div class="global-modal" v-show="topup.loading">
        <div class="global-modal-content">
          <div class="topup-modal">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
            <div class="message">{{ topup.message }}</div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="global-modal" v-show="topup.showSuccess">
        <div class="global-modal-content">
          <div class="topup-modal">
            <i class="fa fa-check-circle fa-2x"></i>
            <div class="message">Top-up was successful.</div>
            <div class="message">
              To check the status of your top-up, log-in to your Stripe Dashboard and go to
              <a target="_blank" :href="stripeConfig.topupURL">Balance <i class="fa fa-arrow-right"></i> Top-ups</a>.
            </div>
            <a class="button cta small block close-button" href="javascript:;" @click="topup.showSuccess = false">OK, I GOT IT.</a>
          </div>
        </div>
      </div>
    </transition>


    <transition name="fade">
      <div class="global-modal" v-show="autodeposit.loading">
        <div class="global-modal-content">
          <div class="topup-modal">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
            <div class="message">{{ autodeposit.message }}</div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="global-modal" v-show="autodeposit.showSuccess">
        <div class="global-modal-content">
          <div class="topup-modal">
            <i class="fa fa-check-circle fa-2x"></i>
            <div class="message">Auto-Deposit was successful.</div>
            <div class="message">
              To check the status of the payouts, log-in to your Stripe Dashboard and go to
              <a target="_blank" :href="stripeConfig.transferURL">Connect <i class="fa fa-arrow-right"></i> Transfers</a>.
            </div>
            <a class="button cta small block close-button" href="javascript:;" @click="autodeposit.showSuccess = false">OK, I GOT IT.</a>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="global-modal" v-show="provBatch.show">
        <div class="global-modal-content">
          <div class="topup-modal providers-modal">
            <div class="message title">{{ provBatch.title }}</div>
            <div class="message type">Drivers with {{ provBatch.type }} payouts.</div>
            <ul>
              <li v-if="provBatch.loading" class="loading">
                <i class="fa fa-spinner fa-spin" ></i> Loading...
              </li>
              <li v-for="prov in provBatch.filteredData" v-if="!provBatch.loading">
                <span :class="['license-type', prov.licenseType]">{{ prov.licenseType }}</span>
                <a v-bind:href="'/#/provider/' + prov.id + '?payouts'" target="_blank">{{ prov.name }}</a>
                <div>
                  <span class="email"><i class="fas fa-envelope"></i> {{ prov.email }}</span>
                  <span class="phone"><i class="fas fa-phone-square"></i> {{ prov.phone }}</span>
                </div>
              </li>
            </ul>
            <a class="button cta small block close-button" @click="provBatch.show = false">close</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import ApiPayouts from '../../modules/api/provider/payouts'
import ft from '@/modules/api/featureToggle'

export default {
  name: 'provider-payouts',
  data () {
    return {
      now: moment(),
      filter: {
        weeks: [],
        selectedWeek: null
      },
      topup: {
        loading: false,
        message: '',
        showSuccess: false
      },
      autodeposit: {
        loading: false,
        message: '',
        showSuccess: false
      },
      er: {
        loading: false,
        pending: 0,
        available: 0,
        reserved: 0
      },
      fct: {
        loading: false,
        pending: 0,
        available: 0,
        reserved: 0
      },
      total: {
        loading: false,
        isOpenBatch: false,
        openBatch: {
          credits: {
            count: [],
            amount: 0
          },
          debits: {
            count: [],
            amount: 0
          }
        },
        check: {
          paid: {
            count: 0,
            amount: 0,
          },
          pending: {
            count: 0,
            amount: 0,
          },
          in_transit: {
            count: 0,
            amount: 0,
          },
          canceled: {
            count: 0,
            amount: 0,
          },
          failed: {
            count: 0,
            amount: 0,
          }
        },
        er: {
          paid: {
            count: 0,
            amount: 0,
          },
          pending: {
            count: 0,
            amount: 0,
          },
          in_transit: {
            count: 0,
            amount: 0,
          },
          canceled: {
            count: 0,
            amount: 0,
          },
          failed: {
            count: 0,
            amount: 0,
          }
        },
        fct: {
          paid: {
            count: 0,
            amount: 0,
          },
          pending: {
            count: 0,
            amount: 0,
          },
          in_transit: {
            count: 0,
            amount: 0,
          },
          canceled: {
            count: 0,
            amount: 0,
          },
          failed: {
            count: 0,
            amount: 0,
          }
        }
      },
      provBatch: {
        date: '',
        data: {},
        filteredData: [],
        show: false,
        loading: false,
        title: '',
        type: ''
      }
    }
  },
  computed: {
    stripeConfig () { return CONFIG.Stripe },
    requiredER () {
      let self = this
      if (self.total.er.pending.amount === 0) {
        return 0
      }
      if (self.er.available > self.total.er.pending.amount) {
        return 0
      }

      return self.total.er.pending.amount - self.er.available
    },
    requiredFCT () {
      let self = this
      if (self.total.fct.pending.amount === 0) {
        return 0
      }
      if (self.fct.available > self.total.fct.pending.amount) {
        return 0
      }

      return self.total.fct.pending.amount - self.fct.available
    }
  },
  methods: {
    init () {
      let self = this
      let start = moment().startOf('isoweek')
      let end = moment(start).endOf('isoweek')
      self.filter.weeks = []
      self.filter.weeks.push({
        start: start,
        end: end
      })
      self.filter.selectedWeek = self.filter.weeks[0]
      let current = moment(start).startOf('isoweek')
      for (let i = 0; i < 7; i++) {
        let startWeek = moment(current).subtract(1, 'd').startOf('isoweek')
        let endWeek = moment(startWeek).endOf('isoweek')
        current = moment(startWeek)

        self.filter.weeks.push({
          start: startWeek,
          end: endWeek
        })
      }
      self.getBalances()
      self.getPayouts()
    },
    refresh () {
      this.getBalances()
      this.getPayouts()
    },
    getBalances () {
      let self = this
      let token = self.$store.state.session.sessionToken

      self.er = {
        loading: true,
        pending: 0,
        available: 0,
        reserved: 0
      }
      ApiPayouts.getBalance(self, { token: token, execRide: true }, r => {
        self.er.loading = false
        if (r.error) {
          return
        }

        let available = 0
        for (let i = 0; i < r.result.available.length; i++) {
          available += r.result.available[i].amount
        }
        self.er.available = available / 100

        let pending = 0
        for (let i = 0; i < r.result.pending.length; i++) {
          pending += r.result.pending[i].amount
        }
        self.er.pending = pending / 100

        let reserved = 0
        for (let i = 0; i < r.result.connect_reserved.length; i++) {
          reserved += r.result.connect_reserved[i].amount
        }
        self.er.reserved = reserved / 100
      })

      self.fct = {
        loading: true,
        pending: 0,
        available: 0,
        reserved: 0
      }
      ApiPayouts.getBalance(self, { token: token, firstClass: true }, r => {
        self.fct.loading = false
        if (r.error) {
          return
        }

        let available = 0
        for (let i = 0; i < r.result.available.length; i++) {
          available += r.result.available[i].amount
        }
        self.fct.available = available / 100

        let pending = 0
        for (let i = 0; i < r.result.pending.length; i++) {
          pending += r.result.pending[i].amount
        }
        self.fct.pending = pending / 100

        let reserved = 0
        for (let i = 0; i < r.result.connect_reserved.length; i++) {
          reserved += r.result.connect_reserved[i].amount
        }
        self.fct.reserved = reserved / 100
      })
    },
    getPayouts () {
      let self = this

      self.total.loading = true
      self.total.check = {
        paid: { count: 0, amount: 0 },
        pending: { count: 0, amount: 0 },
        in_transit: { count: 0, amount: 0 },
        canceled: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 }
      }
      self.total.er = {
        paid: { count: 0, amount: 0 },
        pending: { count: 0, amount: 0 },
        in_transit: { count: 0, amount: 0 },
        canceled: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 }
      }
      self.total.fct = {
        paid: { count: 0, amount: 0 },
        pending: { count: 0, amount: 0 },
        in_transit: { count: 0, amount: 0 },
        canceled: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 }
      }
      if (self.filter.selectedWeek.start.isSame(self.filter.weeks[0].start)) {
        self.total.isOpenBatch = true
        self.getTransactions()
        return
      }

      self.total.isOpenBatch = false
      ApiPayouts.getTotal(self, {
        token: self.$store.state.session.sessionToken,
        since: self.filter.selectedWeek.start.format('YYYY-MM-DD'),
        until: self.filter.selectedWeek.end.format('YYYY-MM-DD')
      }, r => {
        self.total.loading = false
        if (r.error) {
          return
        }
        self.total.check = r.check
        self.total.er = r.execRide
        self.total.fct = r.firstClass
      })
    },
    getTransactions() {
      let self = this
      self.total.openBatch = {
        credits: {
          count: [],
          amount: 0
        },
        debits: {
          count: [],
          amount: 0
        }
      }
      ApiPayouts.getTransactions(self, {
        token: self.$store.state.session.sessionToken,
        since: self.filter.selectedWeek.start.format('YYYY-MM-DD'),
        until: self.filter.selectedWeek.end.format('YYYY-MM-DD'),
        deleted: 0,
        payoutBatchId: null
      }, r => {
        self.total.loading = false
        if (r.error) {
          return
        }
        for (let i = 0; i < r.list.length; i++) {
          let item = r.list[i]
          if (item.type === 'debit') {
            if (self.total.openBatch.debits.count.indexOf(item.contactId) < 0) {
              self.total.openBatch.debits.count.push(item.contactId)
            }
            self.total.openBatch.debits.amount += item.amount
            continue
          }
          if (self.total.openBatch.credits.count.indexOf(item.contactId) < 0) {
            self.total.openBatch.credits.count.push(item.contactId)
          }
          self.total.openBatch.credits.amount += item.amount
        }
      })
    },
    createTopup (isExecRide) {
      let self = this
      let request = {
        token: self.$store.state.session.sessionToken,
        amount: 0,
        currency: 'usd',
        description: 'Top-up for driver payout.',
        metadata: {
          batchStart: self.filter.selectedWeek.start.format('MM/DD/YYYY'),
          batchEnd: self.filter.selectedWeek.end.format('MM/DD/YYYY')
        },
        statementDescriptor: 'Stripe Top-up'
      }
      let amount = 0

      if (isExecRide) {
        amount = parseInt(parseFloat((self.requiredER * 100).toFixed(2)), 10)
        console.log(self.requiredER)
        request['execRide'] = true
      } else {
        amount = parseInt(parseFloat((self.requiredFCT * 100).toFixed(2)), 10)
        request['firstClass'] = true
      }

      if (amount <= 0) {
        return
      }
      request.amount = amount
      self.topup.showSuccess = false
      self.topup.loading = true
      self.topup.message = 'Sending funds to ' + (isExecRide ? 'Executive Ride...' : 'First Class Transportation...')
      ApiPayouts.createTopup(self, request, r => {
        console.log(r)
        self.topup.loading = false
        self.topup.message = ''
        if (r.error) {
          // show error message
          return
        }

        self.topup.showSuccess = true
        self.refresh()
      })
    },
    startAutodeposit (execRide) {
      let self = this

      self.autodeposit.showSuccess = false
      self.autodeposit.loading = true
      self.autodeposit.message = 'Sending payment to driver accounts...'

      let ids = self.total.fct.pending.ids
      if (execRide) {
        ids = self.total.er.pending.ids
      }

      ApiPayouts.startAutodeposit(self, {
        token: self.$store.state.session.sessionToken,
        execRide: execRide,
        ids: ids
      }, r => {
        console.log(r)
        self.autodeposit.showSuccess = true
        self.autodeposit.loading = false
        self.autodeposit.message = ''
        if (r.error) {
          return
        }
        self.refresh()
      })
    },
    showProviders (data, title, type) {
      let self = this
      let since = self.filter.selectedWeek.start.format('YYYY-MM-DD')
      let until = self.filter.selectedWeek.end.format('YYYY-MM-DD')

      self.provBatch.show = true
      self.provBatch.loading = true
      self.provBatch.filteredData = []
      self.provBatch.title = title
      self.provBatch.type = type

      if (self.provBatch.date === since + '--' + until) {
        self.getProviderInfo(data)
        return
      }

      ApiPayouts.getProviderBatch(self, {
        token: self.$store.state.session.sessionToken,
        since: since,
        until: until
      }, r => {
        if (!r.error) {
          self.provBatch.date = since + '--' + until
          self.provBatch.data = r.list

          self.getProviderInfo(data)
        }
      })
    },
    getProviderInfo (data) {
      let self = this
      let provIDs = []

      data.ids.forEach(id => {
        provIDs.push(self.provBatch.data.find(x => x.id === id).contactId)
      })

      self.$sdk.get('/provider', {
        token: self.$store.state.session.sessionToken,
        ids: provIDs
      }, r => {
        self.provBatch.loading = false
        r.list.forEach(prov => {
          let phone = prov.phone
          self.provBatch.filteredData.push({
            id: prov.ID,
            name: prov.firstName + ' ' + prov.lastName,
            lastLogin: moment(prov.lastLogin, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false)),
            email: prov.email,
            phone: prov.countryCode + '' + prov.phone,
            licenseType: prov.providerAccountType
          })
        })
      })
    }
  },
  mounted () {
    this.init()
    if (!this.$store.state.session.user.access.hasOwnProperty('PageAdminDriverBatchModifications')) {
      this.$router.push('/thispagedoesnotexist')
      return
    }
  }
}
</script>

<style lang="scss" scoped>
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.section-title {
  margin: 20px 0 0;
  font-size: 14px;
  line-height: 14px;
  color: #555;

  & strong { text-decoration: underline; }
}

.balances {
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 3px 8px rgba(0,0,0,0.3);

  & .account-name {
    font-size: 18px;
    font-weight: 700;
    color: #555;
    margin-bottom: 10px;
  }

  & .balance {
    text-align: right;
    margin-top: 10px;

    & .amount {
      font-size: 24px;
      line-height: 24px;
      color: #0D79F2;
      margin-bottom: 5px;
    }

    & .label {
      font-size: 12px;
      font-weight: 700;
      color: #777;
    }
  }
}

.totals-group {

  & .group-label {
    font-size: 12px;
    font-weight: 700;
    color: #777;
  }
}

.group-separator {
  height: 0;
  border-top: 1px dashed rgba(0,0,0,0.5);
  margin: 15px 0;
}

.select-input {
  text-align: right;
  & label {
    font-size: 14px;
    font-weight: 700;
    margin-right: 10px;
    color: #777;
  }

  & select {
    margin-top: 5px;
    border: 1px solid #ccc;
    padding: 10px;
    color: #333;
    height: 40px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('/assets/img/down.png') no-repeat 173px 9px;
    transition: all .35s ease;
    width: 200px;
    background-color: #fff;
  }
}

.topup-modal {
  width: 400px;
  margin: 0 auto;
  text-align: center;
  background-color: #fff;
  border-radius: 7px;
  padding: 20px 15px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  color: #777;

  & .fa-check-circle { color: #26D97A; }
  & .message {
    margin-top: 10px;
    color: #555;
    font-size: 16px;
  }
  & .close-button { margin-top: 20px; }
  &.providers-modal{
    width: 500px;

    .message{ margin: 0; }
    .title{
      margin-bottom: 0;
      font-weight: 600;
      font-size: 18px;
    }
    .type{
      font-size: 14px;
      color: #888;
      margin-bottom: 15px;
    }
    ul{
      list-style: none;
      display: block;
      margin: 0;
      padding: 0;
      text-align: left;
      border: 1px solid #ddd;
      height: 300px;
      overflow: auto;
      box-shadow: 0 0 2px rgba(0,0,0, .2);

      li{
        padding: 8px 10px;
        border-bottom: 1px solid #eee;
        transition: all .2s ease;
        &:nth-child(even) { background :#F4F8F9; }
      }
      .loading{
        font-style: italic;
        text-align: center;
        padding: 15px;
      }
      a{
        font-size: 15px;
        color: #0d79f2;
        font-weight: 600;
        line-height: 1;
        margin-bottom: 2px;
        cursor: pointer;
      }
      div{
        line-height: 1;

        span{
          font-size: 13px;
          color: #aaa;

          i{
            vertical-align: middle;
            margin-right: 1px;
          }
        }
      }
      .email{ margin-right: 8px; }
    }
  }
}

span.license-type {
  display: inline-block;
  color: #fff;
  padding: 3px 5px;
  min-width: 50px;
  border-radius: 3px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
  text-align: center;
  float: right;

  &.tnc { background-color: #2ab77c; }
  &.tcp { background-color: #3f81a0; }
  &.psc { background-color: #de6c2a; }
}
.controls {
  text-align: right;
  margin-top: 10px;
}
.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.margin-T { margin-top: 15px; }
.margin-B { margin-bottom: 30px; }
.margin-T-z { margin-top: 0 !important; }

.payout-dates { display: inline; }

@media only screen and (max-width: 430px) {
  .row {
    padding: 0 15px;
  }
  .small-4, .small-8, .small-6, .small-7, .small-5 {
    width: 100%
  }

  .padding-L, .padding-R {
    padding: 5px 0;
  }
  .balances {
    .account-name {
      font-size: 15px;
    }
  }


  .section-title {
    text-align: center;
    margin-bottom: 10px;
    margin-top: 5px;
    
    strong {
      display: block;
    }

    .payout-dates {
      display: flex;
      justify-content: center;
      gap: 5px;
      
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/ProviderPayouts/index.vue